// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useEffect, useState } from "react";
import { useAuthSession } from "./useAuthSession";
import { getTenantSettings } from "../features/onboarding/api/tenantSettingsApi";

export type DocumentLogoPosition = "left" | "center" | "right";

export interface TenantBranding {
  logo?: string | undefined;
  logoPosition: DocumentLogoPosition;
  businessName?: string | undefined;
}

export function useTenantBranding(): TenantBranding {
  const { getAccessToken } = useAuthSession();
  const [branding, setBranding] = useState<TenantBranding>({
    logoPosition: "left",
  });

  useEffect(() => {
    let cancelled = false;
    void getAccessToken()
      .catch(() => undefined)
      .then((token) =>
        getTenantSettings({
          refresh: false,
          ...(token !== undefined ? { token } : {}),
        }),
      )
      .then((loaded) => {
        if (cancelled) {
          return;
        }
        const business = loaded.settings.business;
        setBranding({
          logo: business?.logo,
          logoPosition: business?.logoPosition ?? "left",
          businessName: business?.displayName,
        } satisfies TenantBranding);
      })
      .catch(() => {
      });
    return () => {
      cancelled = true;
    };
  }, [getAccessToken]);

  return branding;
}
